import { ITheme } from 'stores/Theme.types'
import { MemberProfile, HomepageDoc, Workspace } from 'types'

export enum WorkspaceActions {
  UPSERT_MEMBER_PROFILE = 'UPSERT_MEMBER_PROFILE',
  SET_WORKSPACE_HOMEPAGE_DOC = 'SET_WORKSPACE_HOMEPAGE_DOC',
  SET_WORKSPACE_PAYING = 'SET_WORKSPACE_PAYING',
  SET_WORKSPACE_COMPANY_SIZE_ENUM = 'SET_WORKSPACE_COMPANY_SIZE_ENUM',
  UPDATE_THEME = 'UPDATE_THEME',
  UPDATE_COLOR_SCHEME = 'UPDATE_COLOR_SCHEME',
  UPDATE_APP_LOGO_URL = 'UPDATE_APP_LOGO_URL',
}

export function upsertMemberProfile(workspaceId: number, profile: MemberProfile) {
  return {
    type: WorkspaceActions.UPSERT_MEMBER_PROFILE,
    payload: { workspaceId, profile },
  }
}

export function setWorkspaceHomepageDoc(payload: { workspaceKey: string; doc: HomepageDoc | null }) {
  return {
    type: WorkspaceActions.SET_WORKSPACE_HOMEPAGE_DOC,
    payload,
  }
}

export function setWorkspacePaying(payload: { workspaceKey: string; paying: boolean; can_start_free_trial: boolean }) {
  return {
    type: WorkspaceActions.SET_WORKSPACE_PAYING,
    payload,
  }
}

export function setWorkspaceCompanySizeEnum(payload: { workspaceKey: string; company_size_enum: number }) {
  return {
    type: WorkspaceActions.SET_WORKSPACE_COMPANY_SIZE_ENUM,
    payload,
  }
}

export function updateWorkspaceTheme(payload: { workspaceKey: string; theme: ITheme }) {
  return {
    type: WorkspaceActions.UPDATE_THEME,
    payload,
  }
}

export function updateWorkspaceColorScheme(payload: { workspaceKey: string; color_scheme: Workspace['color_scheme'] }) {
  return {
    type: WorkspaceActions.UPDATE_COLOR_SCHEME,
    payload,
  }
}

export function updateWorkspaceAppLogoUrl(payload: { workspaceKey: string; app_logo_url: Workspace['app_logo_url'] }) {
  return {
    type: WorkspaceActions.UPDATE_APP_LOGO_URL,
    payload,
  }
}
